import { render, staticRenderFns } from "./AssetDashboardView.vue?vue&type=template&id=87426dcc&scoped=true"
import script from "./AssetDashboardView.vue?vue&type=script&lang=js"
export * from "./AssetDashboardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87426dcc",
  null
  
)

export default component.exports